import { fmt, ddmmyyyy } from "@/lib/format";
import { monthLabel } from "@/pages/SummaryPage";

const Stat = ({ label, value, testId }) => (
  <div className="px-3 sm:px-4 py-3 min-w-0 border-r border-slate-300 last:border-r-0">
    <p className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500">{label}</p>
    <p className="font-mono text-base sm:text-xl font-semibold tabular-nums mt-0.5 break-words" data-testid={testId}>{value}</p>
  </div>
);

const MonthBlock = ({ m, items, onRowClick }) => (
  <tbody>
    {items.map((it) => (
      <tr key={it.entry_id} data-testid="person-ledger-row" onClick={onRowClick ? () => onRowClick(it, m) : undefined}
        className={`border-t border-slate-200 ${onRowClick ? "cursor-pointer hover:bg-slate-50 transition-colors" : ""}`}>
        <td className="px-3 py-2.5 font-mono whitespace-nowrap">{ddmmyyyy(it.date)}</td>
        <td className={`px-3 py-2.5 text-right font-mono tabular-nums font-semibold ${it.cashout < 0 ? "text-green-700" : "text-orange-800"}`}>{fmt(it.cashout)}</td>
        <td className="px-3 py-2.5 text-right font-mono tabular-nums font-bold bg-orange-50" data-testid="person-ledger-running">{fmt(it.running)}</td>
        <td className="px-3 py-2.5 whitespace-nowrap">
          <span className="font-bold uppercase">{it.book_name}</span>
          {it.sheet === "sett" && <span className="ml-1.5 text-[10px] font-bold bg-amber-200 px-1.5">NEW SETT</span>}
        </td>
        <td className="px-3 py-2.5 text-slate-700">{it.cashout_note}</td>
      </tr>
    ))}
    <tr className="bg-slate-100 border-t border-slate-300" data-testid={`person-ledger-month-${m.month}`}>
      <td className="px-3 py-2 text-xs font-bold uppercase tracking-[0.1em] whitespace-nowrap">{monthLabel(m.month)}</td>
      <td className="px-3 py-2 text-right font-mono tabular-nums font-bold" data-testid="person-ledger-month-total">{fmt(m.total)}</td>
      <td className="px-3 py-2 text-xs text-slate-500" colSpan={3}>{m.count} {m.count === 1 ? "cashout" : "cashouts"}</td>
    </tr>
  </tbody>
);

export const PersonLedgerView = ({ data, onRowClick }) => data.count === 0 ? (
  <div className="border border-dashed border-slate-400 bg-white/60 p-10 text-center" data-testid="person-ledger-empty">
    <p className="font-semibold">No cashouts for this person</p>
  </div>
) : (
  <>
    <div className="grid grid-cols-3 bg-white border border-slate-300 fade-up">
      <Stat label="Total cashout" value={fmt(data.total)} testId="person-ledger-total" />
      <Stat label="Cashouts" value={data.count} testId="person-ledger-count" />
      <Stat label="Period" value={`${ddmmyyyy(data.items[0].date).slice(3)} → ${ddmmyyyy(data.items[data.items.length - 1].date).slice(3)}`} testId="person-ledger-period" />
    </div>
    <section className="bg-white border border-slate-300 fade-up" data-testid="person-ledger-table">
      <div className="ledger-scroll overflow-x-auto">
        <table className="w-full min-w-[600px] text-sm">
          <thead className="text-[10px] uppercase tracking-[0.12em] text-slate-500 bg-slate-50">
            <tr>{["Date", "Cashout", "Running total", "Book", "Description"].map((h, i) => <th key={h} className={`px-3 py-2 font-bold whitespace-nowrap ${i === 1 || i === 2 ? "text-right" : "text-left"}`}>{h}</th>)}</tr>
          </thead>
          {data.months.map((m) => (
            <MonthBlock key={m.month} m={m} onRowClick={onRowClick} items={data.items.filter((i) => i.date.startsWith(m.month))} />
          ))}
        </table>
      </div>
    </section>
  </>
);
